module.exports = __webpack_public_path__ + "img/finance_detail_2.eca6df4a.svg";